import { gql } from '@apollo/client';

export const CREATE_ANSWER = gql`
    mutation createAnswer($input: CreateAnswerInput!) {
        createAnswer(input: $input) {
            id
            created
            updated
            userId
            questionId
            contextType
            contextId
            value
            valueType
            isSkipped
        }
    }
`;
export const SKIP_ALL_QUIZZES = gql`
    mutation skipAllQuizzes($input: SkipAllQuizzesInput!) {
        skipAllQuizzes(input: $input) {
            message
        }
    }
`;
export const CREATE_ANSWERS = gql`
    mutation createAnswers($input: CreateAnswersInput!) {
        createAnswers(input: $input) {
            id
            created
            updated
            userId
            questionId
            contextType
            contextId
            value
            valueType
            isSkipped
        }
    }
`;

export const DELETE_ANSWER = gql`
    mutation deleteAnswer($input: DeleteAnswerInput!) {
        deleteAnswer(input: $input) {
            message
        }
    }
`;

export enum ValueType {
    Boolean = 'BOOLEAN',

    BooleanList = 'BOOLEAN_LIST',

    Float = 'FLOAT',

    FloatList = 'FLOAT_LIST',

    Int = 'INT',

    IntList = 'INT_LIST',

    String = 'STRING',

    StringList = 'STRING_LIST',
}

export const CREATE_QUESTION_DATA = gql`
    mutation createQuestionData($input: CreateQuestionDataInput!) {
        createQuestionData(input: $input) {
            id
            subject
            title
            descriptions
            tags
            value
            type
            imageUrl
            default
            displayOrder
            enabled
            creator
            created
            updater
            updated
        }
    }
`;
